<template>
	<div class="list-container-wrap container">
		<div class="list-info d-flex" @click="handleClickItem(item)">
			<div class="info-avatar">
				<img class="avatar" :src="item.icon ? item.icon : `${imgPath}/user.png`">
			</div>
			<div class="info-item">
				<div class="name">{{item.createUserName}}</div>
				<div class="info-desc d-flex justify-start">
					<div class="date">{{item.publishTime | getTime}}</div>
					<div class="spot">·</div>
					<div class="address">{{item.locationName}}网友</div>
				</div>
			</div>
		</div>
		<div class="list-center" @click="handleClickItem(item)">
			<div class="center-title text-overflow">{{item.title}}</div>
			<div class="center-desc text-ellipsis">
				{{item.content}}
			</div>
		</div>
		<!-- 图片展示 -->
		<div class="list-images" v-if="item.attachmentList && item.attachmentList.length > 0">
			<!-- 单图 -->
			<template v-if="item.attachmentList.length == 1">
				<div class="big-img" v-for="img in item.attachmentList" :ket="img.videoPictureUrl">
					<img v-if="img.fileType == 0" class="img" :src="img.fileUrl">
					<div v-if="img.fileType == 1&&isImage(img.videoPictureUrl)" class="video-img">
						<img class="video" src="../../static/video.png">
						<img :src="img.videoPictureUrl" class="img">
					</div>
					<div v-if="!isImage(img.videoPictureUrl)&&img.fileType == 1" class="video-img">
						<img class="video" src="../../static/play.png">
						<img src="../../static/videobg.png" class="img" >
					</div>
				</div>
			</template>
			<!-- 多图 -->
			<template v-if="item.attachmentList && item.attachmentList.length > 1 ">
				<div class="small-img">
					<template  v-for="imgs in item.attachmentList" :ket="imgs.videoPictureUrl">
						<img v-if="imgs.fileType == 0" class="item" :src="imgs.fileUrl">
						<div v-if="imgs.fileType == 1&&isImage(imgs.videoPictureUrl)" class="video-img">
							<img class="video" src="../../static/play.png">
							<img  :src="imgs.videoPictureUrl" class="item">
						</div>
						<div v-if="!isImage(imgs.videoPictureUrl)&&imgs.fileType == 1" class="video-img">
							<img class="video" src="../../static/play.png">
							<img  src="../../static/videobg.png" class="item">
						</div>
					</template>
					
				</div>
			</template>
		</div>	
		<!-- 联系作者 -->
		<div class="author-list">
			<div class="list-item" v-if="item.mediaNames">
				<template  v-for="name in item.mediaNames.split(' ')">
					<div class="item" v-if="name != ''">
						<div>{{name}}</div>
					</div>
				</template>
				<!-- 记者已关注 -->
				<div class="item reporter" v-if="item.mediaAttentFlag == '1' &&  item.mediaNames.indexOf('疫情防控')<0 && item.mediaNames.indexOf('灾后重建')<0">
					<div>记者已关注</div>
				</div>
			</div>
			<div class="list-item" v-if="item.creporterName">
				<div class="list-name">{{item.creporterName}}</div>
				<div class="list-name" style="background: #eaf7ff;color: #036eb8;" v-if="item.creporterAttentFlag == 1 &&  item.mediaNames.indexOf('疫情防控')<0 && item.mediaNames.indexOf('灾后重建')<0">记者已关注</div>
				</div>
			<div class="list-item" v-if="item.cmediaName">
				<div class="list-name">{{item.cmediaName}}</div>
				<div class="list-name" v-if="item.cmediaDealFlag == 1  &&  item.mediaNames.indexOf('疫情防控')<0 && item.mediaNames.indexOf('灾后重建')<0" style="background: #FCE0DE;color: #F8332E;">县域融媒已办理</div>
			</div>
		</div>
		<!-- 融媒体@回复人 -->
		<div class="reply-wrap" v-if="item.hlHottestCmedia && item.hlHottestCmedia.cmediaReplyContent">
			<div class="reply-info">
				<img class="user" src="../../static/user.png">
				<div class="name">
					<div class="title">
						<div class="media">{{item.cmediaName}}</div>
						<div class="author">@{{item.createUserName}}</div>
					</div>
					<div class="date">{{item.hlHottestCmedia.cmediaReplyTime}}</div>
				</div>
			</div>
			<div class="center">{{item.hlHottestCmedia.cmediaReplyContent}}</div>
		</div>
		<!-- 是否已采访 -->
		<div class="handled" v-if="item.mediaDealFlag == 1">
			<img v-if="item.mediaNames.indexOf('疫情防控')>0 || item.mediaNames.indexOf('灾后重建')>0" class="icon"  :src="`${imgPath}/dealed2x.png`">
			<img v-else class="icon" :src="`${imgPath}/haddeal.png`">
		</div>
		<div class="handled" v-if="item.cmediaDealFlag == 1">
			<img class="icon" :src="`${imgPath}/dealed2x.png`">
		</div>

	</div>
</template>

<script>
	 import  { getTimer,imgPath } from "@/util/timer.js"
	export default {
		name: "List",
		props:{
			item:{
				type:Object,
				default: ()=>{}
			}
		},
		data() {
			return {
				imgPath:imgPath,
			};
		},
		filters:{
			getTime(val) {
				return getTimer(val)
			}
		},
		methods:{
			_getQueryString(name) {
				let reg = new RegExp('[?&]' + name + '=([^&#]*)', 'i');
				let res = window.location.href.match(reg);
				if (res && res.length > 1) {
				  return decodeURIComponent(res[1]);
				}
				return '';
			},
			isImage(str) {
			    var reg = /\.(png|jpg|gif|jpeg|webp)$/;
			    return reg.test(str);
			},
			handleClickItem(item) {
				console.log("跳到这个你问也")
				this.$router.push({ name: 'detail', query: { id: item.id } })
			}
		}
	}
</script>
<!-- @import '../../styles/index.css'; -->
<style lang="scss" scoped>
	.list-container-wrap {
		cursor: pointer;
		background-color:#ffffff;
		position:relative;
		// display: flex;
		// flex-direction: column;
		padding: 22px 22px;
		border-bottom: 1px solid #F4F4F4;
		.list-info {
			.info-avatar {
				width: 44px;
				height: 44px;

				.avatar {
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}

			.info-item {
				padding-left: 10px;
				.name {
					font-size: 14px;
					color: #444444;
					font-weight: 700;
				}

				.info-desc {
					padding-top:5px;
					font-size: 12px;
					color: #999999;

					.spot {
						display: inline-block;
						padding: 0 5px;
					}
				}
			}
		}

		.list-center {
			margin-top:14px;
			color: #444444;

			.center-title {
				font-size: 18px;
				font-weight: 700;
			}

			.center-desc {
				font-size: 14px;
				font-weight: 500;
				line-height: 1.5;
				margin-top: 11px;
			}
		}

		.list-images {
			margin-top:15px;
			.big-img {
				width: 158px;
				height: 88px;
				overflow: hidden;

				.img {
					width: 158px;
					height: 88px;
					object-fit: cover;
				}
				.video-img {
					position: relative;
					width: 158px;
					height: 88px;
					overflow: hidden;
					object-fit: cover;
					.video {
						display: block;
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						margin: auto;
						width: 32px;
						height: 32px;
						z-index: 99999;
					}
				}
			}

			.small-img {
				display: flex;
				flex-wrap: wrap;
				justify-content: flex-start;
				margin-top:15px;
				.item {
					display: block;
					width: 158px;
					margin-right: 10px;
					height: 88px !important;
					margin-bottom: 15px;
					overflow: hidden;
					border-radius: 5px;
					object-fit: cover;
				}
				.item:nth-child(3n+0) {
					margin-right: 0;
				}
				.video-img {
					position: relative;
					width: 158px;
					height: 88px !important;
					object-fit: cover;
					overflow: hidden;
					.video {
						display: block;
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						margin: auto;
						width: 32px;
						height: 32px;
						z-index: 99999;
					}
				}
			}
		}

		.author-list {
			margin-top:10px;
			display: flex;
			flex-direction: column;
			.list-item {
				display: flex;
				flex-wrap: wrap;
				.item {
					height: 36px;
					line-height: 36px;
					background: #f8f8f8;
					color: #666666;
					font-size:14px;
					margin-bottom:10px;
					margin-right: 10px;
					border-radius: 5px;
					padding: 0 10px;
				
					.address {
						display: inline-block;
						width: 16px;
						height: 22px;
						margin-right: 12px;
					}
				}
				.reporter {
					background: #ffedd8;
					color: #ED9027;
				}
			}
			.list-name {
				display: block;
				height: 36px;
				line-height: 36px;
				color: #666666;
				font-size:14px;
				margin-bottom: 10px;
				margin-right: 10px;
				border-radius: 5px;
				padding: 0 10px;
				width: auto;
				background: #f8f8f8;
			}

			.reporter {
				color: #ED9027;
				background: #ffedd8;
			}

			.county {
				color: #F8332E;
				background: #fce0de;
			}
		}
		
		.reply-wrap {
			padding-top: 20px;
			border-top: 1px solid #F4F4F4;
			.reply-info {
				display: flex;
				align-items: center;
				.user {
					width: 90px;
					height: 90px;
					border-radius: 50%;
				}
				.name {
					padding-left: 15px;
					.title {
						.media {
							color: #444444;
							font-weight: bold;
						}
						.author {
							font-size: 16px;
							color: #036EB8;
							font-weight: 700;
							padding-left: 20px;
						}
					}
					.date {
						font-size: 24px;
						color: #999999;
						padding-top: 10px;
					}
				}
			}
			.center {
				font-size: 32px;
				font-weight: 500;
				line-height: 1.5;
				color: #444444;
				padding: 30px 0;
				padding-left: 100px;
			}
		}

		.operation-wrap {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 28px;
			padding: 0 90px;
			margin-bottom: 50px;
			.list-item {
				display: flex;

				.icon {
					width: 35px;
					height: 35px;
				}

				text {
					font-size: 26px;
					color: #666666;
					padding-left: 15px;
				}
			}
		}
		.handled {
			position: absolute;
			top: 20px;
			right: 20px;
			.icon {
				width: 100px;
				height: 80px;
			}
		}
	}
</style>